import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseIcon } from '../BaseIcon';
export const VerticalEllipsis = ({ height = '16px', width = '6px', fill = '#282828', ...rest }) => {
    return (_jsxs(BaseIcon, { width: width, height: height, viewBox: '0 0 6 16', fill: 'none', ...rest, children: [_jsx("circle", { cx: '3', cy: '1.6', r: '1.6', fill: fill }), _jsx("circle", { cx: '3', cy: '8', r: '1.6', fill: fill }), _jsx("circle", { cx: '3', cy: '14.4', r: '1.6', fill: fill })] }));
};
//# sourceMappingURL=VerticalEllipsis.js.map